<template>
  <div style="height: 100%; display: flex; flex-direction: column">
    <div
      v-if="
        router.currentRoute.value.fullPath !== '/call' &&
        router.currentRoute.value.fullPath !== '/todayorder'
      "
      class="flex-nowrap flex"
      type="flex"
      style="
        margin-bottom: 11px;
        height: 58px;
        background: transparent;
        align-items: center;
        border-radius: 6px;
      "
    >
      <el-popover placement="bottom-start" width="35%" trigger="click">
        <div class="w-full">
          <div class="flex justify-between">
            <div class="">区域列表</div>
            <div class="flex items-center">
              只看空桌<el-switch
                class="ml-2"
                v-model="isEmptyDesk"
                @change="arealistItemClick()"
                active-color="#ff4949"
                inactive-color="#ddd"
              >
              </el-switch>
            </div>
          </div>
          <div class="flex flex-wrap my-3">
            <div
              class="flex justify-center items-center w-28 ml-3 mb-3 bg-black bg-opacity-5 h-10 cursor-pointer"
              :class="{ 'area-active': area.select }"
              v-for="area in arealistBak"
              :key="area.areaid"
              @click="arealistItemClick(area)"
            >
              {{ area.areaname }}
            </div>
          </div>
        </div>
        <template #reference>
          <div
            class="meal-today !bg-white !ml-2 border border-solid"
            style="border-color: #fe5353"
          >
            <div><img src="@/assets/shaixuan.svg" alt="" /></div>
            <div class="mt-1" style="color: #fe5353">筛选</div>
          </div>
        </template>
      </el-popover>
      <div class="meal-message flexbox" style="position: relative">
        <div
          class="datebox flex-col justify-center"
          style="
            background: transparent;
            color: #333333;
            margin-right: 0;
            color: #ffffff;
            margin-left: 10px;
          "
        >
          <img
            style="width: 23px; height: 22px"
            src="@/assets/banquet-img/rili2.png"
            alt=""
          />日历
        </div>
        <div class="meal-date" style="margin-left: 15px">
          <div style="font-size: 16px; font-weight: bold">
            {{ mealDate }}
          </div>
          <!-- <div>{{farmingDate}}</div> -->
          <div>
            {{
              calendar.solar2lunar(
                mealDate.split("-")[0],
                mealDate.split("-")[1],
                mealDate.split("-")[2]
              ).ncWeek +
              "&nbsp;&nbsp;" +
              calendar.solar2lunar(
                mealDate.split("-")[0],
                mealDate.split("-")[1],
                mealDate.split("-")[2]
              ).IMonthCn +
              calendar.solar2lunar(
                mealDate.split("-")[0],
                mealDate.split("-")[1],
                mealDate.split("-")[2]
              ).IDayCn
            }}
          </div>
        </div>
        <!-- <div style="text-align: center;">
                    <img src="@/assets/banquet-img/zaocan-baozi.png" style="width: 29px;height: 27px;display: block;" alt="">{{mealtype.segmentname}}
                </div> -->
        <el-popover placement="bottom" width="390" trigger="click">
          <div style="width: 100%">
            <banquet-calendar
              ref="banquetCalendar"
              v-if="calShow"
              :selectDate="mealDate"
              :mealtypes="mealtypes"
              @choiceDate="changeDate"
              @selectMeat="selectMeat"
            ></banquet-calendar>
          </div>
          <template #reference>
            <div
              style="
                width: 100%;
                height: 100%;
                position: absolute;
                top: 0;
                left: 0;
              "
            ></div>
          </template>
        </el-popover>
      </div>
      <div class="meal-today" @click="toToday">
        <div class="meal-today-icon">今</div>
        <div>今天</div>
      </div>
      <div
        class="header-databox flexbox"
        style="margin-left: 2px; height: 100%"
      >
        <!-- <div class="datebox" @click="switchDay(1)" :class="choiceDay===1?'select':''">
                    <div class="iconimg">今</div>{{todayDate}}
                </div>
                <div class="datebox" @click="switchDay(2)" :class="choiceDay===2?'select':''">
                    <div class="iconimg">明</div>{{tomorrowDate}}
                </div>
                <div class="datebox" @click="switchDay(3)" :class="choiceDay===3?'select':''">
                    <div class="iconimg">后</div>{{afterTomorrow}}
                </div> -->
        <div
          class="datebox"
          :class="choiceDay === i + 1 ? 'select' : ''"
          v-for="(d, i) in datelist"
          :key="i"
        >
          <div
            style="font-size: 16px"
            class="datebox-day h-full w-[52px] flex flex-col justify-center items-center"
            :class="
              new Date().getDate().toString() === d.date.toString().trim()
                ? 'to-day'
                : ''
            "
          >
            <span
              class="datebox-date font-semibold"
              style="
                font-size: 20px;
                color: #666666;
                font-family: PingFangSC, PingFang SC;
              "
            >
              {{ d.date }}</span
            >
            <div class="iconimg">{{ d.name }}</div>
          </div>
          <div class="mealslot-box flexbox" style="height: 100%">
            <div
              :key="types.segmenttype"
              v-for="types in mealtypes"
              style="height: 100%"
            >
              <!-- <el-tooltip
                                v-if="(mealDate+' '+types.endtime)<nowTime"
                                effect="light"
                                content="餐段时间已过"
                                placement="bottom"
                            >
                                <div class="meal-slot disabletime">
                                    <span class="border-color"><img :src="mealTypeImageList[types.segmenttype-1]" alt=""></span>{{types.segmentname}}
                                </div>
                            </el-tooltip>
                            <div v-else @click="choiceMealtype(types)" :class="mealtype.segmenttype===types.segmenttype?'select':''" class="meal-slot">
                                <span class="border-color"><img :src="mealTypeImageList[types.segmenttype-1]" alt=""></span>{{types.segmentname}}
                            </div> -->
              <div
                @click="choiceMealtype(types, i + 1)"
                :class="{
                  select:
                    mealDate === d.dateTime &&
                    mealtype.segmenttype === types.segmenttype,
                  'to-day':
                    new Date().getDate().toString() ===
                    d.date.toString().trim(),
                }"
                class="meal-slot"
              >
                <span class="border-color"
                  ><img
                    :src="mealTypeImageList[types.segmenttype - 1]"
                    alt="" /></span
                >{{ types.segmentname }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="flex" style="flex: 1; padding: 0px; overflow: hidden">
      <div
        class="outbox"
        :span="callShow ? 9 : 14"
        style="height: 100%; overflow: hidden"
      >
        <div
          class="h-full"
          style="
            padding: 0px 12px 8px 12px;
            background: #ffffff;
            box-sizing: border-box;
            min-height: 100%;
          "
        >
          <div class="tablelist-box">
            <div class="line-content" @click="deskClick">
              <div class="flex">
                <div class="w-[110px]">
                  {{
                    mealDate.substring(5, mealDate.length) +
                    "（" +
                    calendar.solar2lunar(
                      mealDate.split("-")[0],
                      mealDate.split("-")[1],
                      mealDate.split("-")[2]
                    ).ncWeek +
                    "）"
                  }}
                </div>
                <div class="flex-1">
                  <div v-for="(item, i) in deskSegmentStatiscsBak" :key="i">
                    {{
                      item.segmentName +
                      "&nbsp;&nbsp;&nbsp;&nbsp;" +
                      "预订" +
                      item.countOrdered +
                      "桌" +
                      "&nbsp;&nbsp;" +
                      "散客" +
                      item.countFit +
                      "桌" +
                      "&nbsp;&nbsp;" +
                      "预留" +
                      item.countRevered +
                      "桌"
                    }}
                  </div>
                </div>
              </div>
              <el-icon v-if="isSprand"><ArrowDownBold /></el-icon>
              <el-icon v-else><ArrowUpBold /></el-icon>
            </div>
            <div class="outbox overflow-auto">
              <div v-for="area in arealist" :key="area.areaid" class="hall-box">
                <div class="hall-name">
                  {{ area.areaname }}（{{ area.desklist.length }}桌）
                </div>
                <div class="hall-list">
                  <template
                    v-for="desk in area.desklist"
                    :key="desk.desk.deskid"
                  >
                    <div
                      class="hall"
                      :style="{
                        '--sanke-back-color': colors.sankeBackColor,
                        '--sanke-front-color': colors.sankeFrontColor,
                        '--yvding-back-color': colors.yvdingBackColor,
                        '--ding-back-fotter': colors.dingBackFotterColor,
                        '--select-back-color': colors.selectBackColor,
                      }"
                    >
                      <div
                        class="h-full"
                        @click="selectTable(desk, desk.ordertype)"
                        v-if="selectDeskId.indexOf(desk.desk.deskid) < 0"
                      >
                        <div
                          v-if="
                            desk.order && desk.order[0].intentplantables > 1
                          "
                          class="bg-white ml-2 w-5 h-5 justify-center font-bold text-sm flex items-center absolute top-0.5 right-0.5 z-1"
                          style="color: #ff9e9e; border-radius: 50%"
                        >
                          连
                        </div>
                        <div v-if="desk.orderstatus === 2" class="yvding">
                          <div class="desk-name">
                            {{ desk.desk.deskname }}
                          </div>
                          <div class="empty-body">
                            {{ desk.order[0].customer.customerInfo }}
                          </div>
                          <div
                            class="desk-fotter"
                            style="
                              justify-content: center;
                              background-color: #edf4ff;
                            "
                          >
                            <span class="fotter-name" style="color: #448af8"
                              >客到</span
                            >
                          </div>
                        </div>
                        <div v-else-if="desk.ordertype === 5" class="yan">
                          <div class="desk-name">{{ desk.desk.deskname }}</div>
                          <div class="empty-body" v-if="!showTableType">
                            {{ desk.desk.peoplemin }}~{{
                              desk.desk.peoplemax
                            }}人
                          </div>
                          <div class="empty-body" v-if="showTableType">
                            {{ desk.desk.tableType }}&nbsp;
                          </div>
                          <div class="yan-fotter desk-fotter">
                            <span class="fotter-name">{{
                              desk.order[0].receiverordername
                            }}</span
                            >宴
                          </div>
                        </div>
                        <div
                          v-else-if="desk.ordertype === 1"
                          class="yvding relative"
                        >
                          <div class="desk-name flex justify-center">
                            {{ desk.desk.deskname }}
                          </div>
                          <div class="empty-body-ding">
                            <!-- {{desk.desk.peoplemin}}~{{desk.desk.peoplemax}}人 -->
                            {{
                              desk.order[0].customer.fullname.length === 1
                                ? desk.order[0].customer.lastname +
                                  (desk.order[0].customer.sex === 0
                                    ? "女士"
                                    : "先生")
                                : desk.order[0].customer.fullname
                            }}
                            {{ " " + desk.order[0].customer.phone.substr(-4) }}
                          </div>
                          <div class="ding-fotter desk-fotter">
                            <span class="fotter-name-ding">{{
                              desk.order[0].receiverordername
                            }}</span>
                            <span class="fotter-name-ding"
                              >{{ desk.order[0].intentPlanPeoples }}人</span
                            >
                          </div>
                        </div>
                        <div v-else-if="desk.ordertype === 2" class="yvliu">
                          <div class="desk-name">{{ desk.desk.deskname }}</div>
                          <img
                            style="width: 20px; margin: 2px auto"
                            src="@/assets/banquet-img/yvliu-desk.png"
                            alt=""
                          />
                          <div class="liu-fotter desk-fotter">
                            <span class="fotter-name">{{
                              desk.order[0].receiverordername
                            }}</span
                            >留
                          </div>
                        </div>
                        <el-tooltip
                          v-else-if="desk.ordertype === 6"
                          class="box-item"
                          :content="'锁台原因：' + desk.lockReason"
                          placement="top"
                        >
                          <div class="suotai">
                            <div class="desk-name">
                              {{ desk.desk.deskname }}
                            </div>
                            <img
                              style="width: 20px; margin: 2px auto"
                              src="@/assets/banquet-img/suotai-desk.png"
                              alt=""
                            />
                            <div class="suotai-fotter">锁台</div>
                          </div>
                        </el-tooltip>
                        <el-tooltip
                          v-else-if="desk.ordertype === 7"
                          class="box-item"
                          :content="'锁台原因：' + desk.lockReason"
                          placement="top"
                        >
                          <div class="suotai">
                            <div class="desk-name">
                              {{ desk.desk.deskname }}
                            </div>
                            <img
                              style="width: 20px; margin: 2px auto"
                              src="@/assets/banquet-img/suotai-desk.png"
                              alt=""
                            />
                            <div class="suotai-fotter">
                              {{ desk.remark }}
                            </div>
                          </div>
                        </el-tooltip>
                        <div
                          v-else-if="desk.orderLock === 11"
                          class="h-full flex flex-col justify-between"
                        >
                          <div class="suotai">
                            <div class="desk-name">
                              {{ desk.desk.deskname }}
                            </div>
                            <img
                              style="width: 20px; margin: 2px auto"
                              src="@/assets/banquet-img/yvding-lock.png"
                              alt=""
                            />
                            <div class="suotai-fotter">预订权限</div>
                          </div>
                        </div>
                        <div v-else-if="desk.ordertype === 4" class="sanke">
                          <div class="desk-name">{{ desk.desk.deskname }}</div>
                          <div
                            class="empty-body fotter-name-san"
                            v-if="!showTableType"
                          >
                            {{ desk.desk.peoplemin }}~{{
                              desk.desk.peoplemax
                            }}人
                          </div>
                          <div class="empty-body" v-if="showTableType">
                            {{ desk.desk.tableType }}&nbsp;
                          </div>
                          <div class="san-fotter desk-fotter">
                            <span class="fotter-name-san">{{
                              desk.order[0].receiverordername
                            }}</span
                            >散
                          </div>
                        </div>
                        <div
                          v-else
                          class="h-full flex flex-col justify-between"
                        >
                          <div class="desk-name">{{ desk.desk.deskname }}</div>
                          <div class="empty-body" v-if="!showTableType">
                            {{ desk.desk.peoplemin }}~{{
                              desk.desk.peoplemax
                            }}人
                          </div>
                          <div class="empty-body" v-if="showTableType">
                            {{ desk.desk.tableType }}&nbsp;
                          </div>
                          <div
                            class="empty-fotter flex justify-center items-center"
                          >
                            空台
                          </div>
                        </div>
                      </div>
                      <div
                        @click="selectTable(desk)"
                        v-else
                        class="select-deskbox"
                      >
                        <div class="desk-name">{{ desk.desk.deskname }}</div>
                        <div class="select-desk" v-if="!showTableType">
                          {{ desk.desk.peoplemin }}~{{ desk.desk.peoplemax }}人
                        </div>
                        <div class="select-desk" v-if="showTableType">
                          {{ desk.desk.tableType }}&nbsp;
                        </div>
                        <div
                          style="
                            position: absolute;
                            z-index: 10;
                            bottom: 0;
                            left: 0;
                            width: 100%;
                          "
                        >
                          <div
                            v-if="desk.ordertype === 2"
                            class="liu-fotter desk-fotter"
                          >
                            <span class="fotter-name">{{
                              desk.order[0].receiverordername
                            }}</span
                            >留
                          </div>
                          <div
                            v-if="desk.ordertype === 4"
                            class="san-fotter desk-fotter"
                          >
                            <span class="fotter-name-san">{{
                              desk.order[0].receiverordername
                            }}</span
                            >散
                          </div>
                          <div
                            v-if="desk.ordertype === 5"
                            class="yan-fotter desk-fotter"
                          >
                            <span class="fotter-name">{{
                              desk.order[0].receiverordername
                            }}</span
                            >宴
                          </div>
                          <div
                            v-if="desk.ordertype === 1"
                            class="ding-fotter desk-fotter"
                          >
                            <span class="fotter-name-ding">{{
                              desk.order[0].receiverordername
                            }}</span>
                            <span class="fotter-name-ding"
                              >{{ desk.order[0].intentPlanPeoples }}人</span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        :span="6"
        style="
          overflow: hidden;
          margin: 0px 4px;
          padding: 0 10px;
          min-width: 360px;
          max-width: 390px;
        "
        class="screen-calc outbox bg-white flex flex-col"
      >
        <div class="title-tab" v-if="id === '2'">
          <div
            v-if="tab === 1"
            class="w-full items-center flex justify-between"
          >
            <span
              @click="tab = 1"
              :class="tab === 1 ? 'select' : ''"
              style="margin-right: 10px"
            >
              来电记录
            </span>
            <el-button type="text" @click="lookPhone"> 查看来电记录 </el-button>
          </div>
          <span
            v-if="tab === 2"
            @click="tab = 2"
            :class="tab === 2 ? 'select' : ''"
          >
            创建订单
          </span>
        </div>
        <div
          class="outbox callbox flex flex-col overflow-auto"
          style="width: 100%"
        >
          <call-list v-show="tab === 1" @changeTab="changeTab" />
          <CreateOrder
            v-if="tab === 2"
            ref="createOrder"
            :id="id"
            :calendar="calendar"
            :mealDate="mealDate"
            :mealtypes="mealtypes"
            @getDeskList="getDeskList2"
            @deleteDeskList="deleteDeskList"
            @close="orderClose"
            @save="save"
          />
          <div
            v-show="tab === 1"
            @click="changeTab(2)"
            style="height: 50px; min-height: 50px; width: 270px; margin: 0 auto"
            class="conston-btn px-3 flex items-center justify-between w-full"
          >
            <div class="flex items-center">
              <img
                style="width: 16px; height: 16px"
                src="@/assets/order/add.png"
                class="mr-2"
              />创建预订单
            </div>
            <div class="flex items-center">
              <!-- 就餐日期 -->
              <span class="ml-2"
                >{{ mealDate.slice(0, mealDate.length) }}
              </span>
              <span class="ml-2 mr-2">{{
                calendar.solar2lunar(
                  mealDate.split("-")[0],
                  mealDate.split("-")[1],
                  mealDate.split("-")[2]
                ).ncWeek
              }}</span>
            </div>
            <div
              class="flex justify-center items-center"
              v-if="mealtypes.length"
            >
              {{
                mealtypes.filter(
                  (p) => p.segmenttype === mealtype.segmenttype
                )[0].segmentname
              }}
            </div>
          </div>
        </div>
      </div>
      <div style="min-width: 590px; max-width: 610px" class="outbox">
        <router-view v-slot="{ Component }">
          <!-- <transition name="fade" mode="out-in"> -->
          <component
            ref="rightContent"
            :calendar="calendar"
            :mealDate="mealDate"
            :mealtypes="mealtypes"
            :mealtype="mealtype"
            :id="id"
            @getDeskList="getDeskList"
            @searchOrder="searchOrder"
            @updateOrder="updateOrder"
            @changeTab="changeTab"
            :is="Component"
          />
          <!-- </transition>   -->
        </router-view>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ArrowDownBold, ArrowUpBold } from "@element-plus/icons-vue";
import {
  onMounted,
  ref,
  onBeforeUnmount,
  nextTick,
  watch,
  computed,
  defineEmits,
} from "vue";
import {
  getDeskOrder,
  findRestaurantMealTime,
  sendOccupyTable,
  clearALlSelectedTables,
} from "@/api/home/home";
import { formatDate, formatWeek } from "@/utils/formatdate";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import callList from "@/views/order/callList.vue";
import calendar from "@/utils/js-calendar-converter";
import CreateOrder from "@/views/order/createOrder";
const emit = defineEmits(["save"]);

import bus from "@/utils/bus";
// import BanquetCalendar from './order/BanquetCalendar.vue';
import BanquetCalendar from "@/components/common/calendar.vue";
import { startWebSocket, stopWebSocket } from "@/utils/helper";
import { ElMessage } from "element-plus";
import { Close } from "@element-plus/icons-vue";
const tab = ref(1); //列表

const isSprand = ref(false);
const deskSegmentStatiscs = ref([]);
const deskSegmentStatiscsBak = ref([]);
const isEmptyDesk = ref(false);
const createOrder = ref(null);
const router = useRouter();
const store = useStore();
const rightContent = ref(null);
const mealtype = ref(store.state.order.mealtype); //当前餐段
const mealtypes = ref([]); //餐段列表
const arealist = ref([]); //区域列表
const arealistBak = ref([]); //区域列表
const calendarShow = ref(false); //是否显示日历
const choiceDay = ref(1); //选中哪天
const selectDeskList = ref([]); //选中的桌位
const selectDeskId = ref([]); //选中的桌位id
const orderSelectId = ref([]); //当前订单选中的桌位id(防止在修改订单时取消桌位选择后桌位变为不可选)
const todayCalDate = ref(formatDate("MM月dd号", new Date()));
// const todayDate = ref(formatDate('M月d号',new Date()));
const nowTime = formatDate("yyyy-MM-dd hh:mm", new Date());
const date = new Date();
const desklist = ref([]);
const mealTypeImageList = [
  require("@/assets/banquet-img/zaocan.png"),
  require("@/assets/banquet-img/shangwucha.png"),
  require("@/assets/banquet-img/wucan.png"),
  require("@/assets/banquet-img/xiawucha.png"),
  require("@/assets/banquet-img/wancan.png"),
  require("@/assets/banquet-img/yexiao.png"),
];

const mealDate = ref(formatDate("yyyy-MM-dd", new Date()));
let datearr = formatDate("yyyy-MM-dd", new Date()).split("-");
const colors = ref({
  sankeBackColor: "#B8D3FF", //最初样式
  //sankeBackColor: '#3E3CF4',//最新样式
  sankeFrontColor: "#448AF8", //最初样式
  //sankeFrontColor: '#F7F7F7',//最新样式
  yvdingBackColor: "#FFC1BD", //最初样式
  //yvdingBackColor: '#E32B3D',//最新样式
  dingBackFotterColor: "#FF5353", //最初样式
  //dingBackFotterColor: '#E32B3D', //最新样式
  selectBackColor: "#3F3CFF", //最初样式
  //selectBackColor: '#25B661',//最新样式
});
if (sessionStorage.getItem("mealdate")) {
  if (
    sessionStorage.getItem("mealdate") < formatDate("yyyy-MM-dd", new Date())
  ) {
    sessionStorage.setItem("mealdate", formatDate("yyyy-MM-dd", new Date()));
  }
  // let datearr = formatDate('yyyy-MM-dd',new Date()).split("-");
  mealDate.value = sessionStorage.getItem("mealdate");
  choiceDay.value = 1; // ((new Date(mealDate.value))-(new Date(formatDate('yyyy-MM-dd',new Date()))))/1000/60/60/24+1;
  datearr = mealDate.value.split("-");
  // if(mealDate.value === formatDate('yyyy-MM-dd',new Date())){
  //     choiceDay.value = 1
  // }else if (mealDate.value === formatDate('yyyy-MM-dd',new Date(datearr[0],datearr[1]-1,datearr[2]-0+1))){
  //     choiceDay.value = 2
  // }else if (mealDate.value === formatDate('yyyy-MM-dd',new Date(datearr[0],datearr[1]-1,datearr[2]-0+2))){
  //     choiceDay.value = 3
  // }else{
  //     choiceDay.value = 0
  // }
}
const callShow = ref(false);

// const farmingDate = ref();
// const tomorrowDate = ref(formatDate('M月d号',new Date(datearr[0],datearr[1]-1,datearr[2]-0+1))); //明天
// const afterTomorrow = ref(formatDate('M月d号',new Date(datearr[0],datearr[1]-1,datearr[2]-0+2))); //后天
const calShow = ref(true);
const showTableType = ref(false); //是否显示台型
const selectedLockDesks = ref([]);
const user = ref(null);
const banquetCalendar = ref(null);
const restaurant = ref(null);
const canselectdesk = computed(() => store.state.order.canselectdesk);
const watchDate = computed(() => store.state.order.date); //监听日期
const watchMealType = computed(() => store.state.order.mealtype);
const datelist = ref([]);
const id = ref("2");
const save = () => {
  id.value = "2";
  tab.value = 1;
  selectDeskId.value = [];
  store.dispatch("canselectdesk", true);
  store.dispatch("changeDesklist", []);
};
const updateOrder = (orderId) => {
  id.value = orderId;
  tab.value = 2;
  nextTick(() => {
    createOrder.value.reload();
  });
};
const changeTab = (type = 1, params) => {
  tab.value = type;
  id.value = "2";
  if (params) {
    //来电记录创建订单，姓名，手机号回显
    nextTick(() => {
      createOrder.value.creatOrder(params);
    });
  }
};
// const setInfo = () => {
//   const data = [];
//   if (selectDeskId.value.length) {
//     arealist.value.forEach((x) => {
//       x.desklist.forEach((p) => {
//         if (selectDeskId.value.includes(p.desk.deskid)) {
//           data.push(p);
//         }
//       });
//     });
//     desklist.value = data;
//     // tab.value = 2;
//     console.log(data);
//   }
// };
const createDateList = (date2 = new Date(mealDate.value)) => {
  datelist.value = [];
  const date_year = date2.getFullYear();
  const date_month = date2.getMonth();
  const date_day = date2.getDate();
  for (let i = 0; i < 7; i++) {
    let date_str = new Date(date_year, date_month, date_day + i);
    datelist.value.push({
      name: "周" + formatWeek(date_str),
      date: date_str.getDate(),
      dateTime: formatDate("yyyy-MM-dd", date_str),
    });
  }
};

const arealistItemClick = (area) => {
  if (area) {
    area.select = !area.select;
  }
  arealist.value = JSON.parse(JSON.stringify(arealistBak.value));
  // arealistBak.value.forEach((p) => {
  //   if (p.areaid === area.areaid) {
  //     p.select = true;
  //   } else {
  //     p.select = false;
  //   }
  // });

  arealist.value = arealistBak.value.filter((p) => p.select);

  if (isEmptyDesk.value) {
    arealist.value = arealist.value.map((p) => ({
      ...p,
      desklist: p.desklist.filter(
        (x) =>
          !x.permissionUserIDList &&
          ![1, 2, 5, 4, 7, 6, 9, 11].includes(x.ordertype)
      ),
    }));
  }
};
watch(watchDate, (newdata) => {
  if (newdata !== formatDate("yyyy-MM-dd", mealDate.value)) {
    mealDate.value = newdata;
    if (mealDate.value === formatDate("yyyy-MM-dd", new Date(mealDate.value))) {
      choiceDay.value = 1;
    } else if (
      mealDate.value ===
      formatDate(
        "yyyy-MM-dd",
        new Date(datearr[0], datearr[1] - 1, datearr[2] - 0 + 1)
      )
    ) {
      choiceDay.value = 2;
    } else if (
      mealDate.value ===
      formatDate(
        "yyyy-MM-dd",
        new Date(datearr[0], datearr[1] - 1, datearr[2] - 0 + 2)
      )
    ) {
      choiceDay.value = 3;
    } else {
      choiceDay.value = 0;
    }
    if (mealtype.value.segmenttype) {
      getDeskList();
    }
  }
});
watch(watchMealType, (newdata) => {
  if (JSON.stringify(newdata) !== JSON.stringify(mealtype.value)) {
    mealtype.value = newdata;
    if (mealDate.value) {
      getDeskList();
    }
  }
});
store.dispatch("changeDate", mealDate.value);
const toToday = () => {
  banquetCalendar.value.toToday();
};
// 跳转创建订单
const toCreate = () => {
  // console.log(mealDate.value+' '+mealtype.value.endtime,nowTime)
  if (mealDate.value + " " + mealtype.value.endtime > nowTime) {
    router.push({ path: "/createorder/2" });
  } else {
    ElMessage({
      message: "餐段时间已过，不允许创建订单",
      type: "error",
    });
  }
};
const searchOrder = (data) => {
  const name = mealtypes.value.filter(
    (p) => p.segmenttype === mealtype.value.segmenttype
  )[0]?.segmentname;
  if (data.deskSegmentStatiscs) {
    deskSegmentStatiscs.value = data.deskSegmentStatiscs;
    deskSegmentStatiscsBak.value = JSON.parse(
      JSON.stringify(deskSegmentStatiscs.value)
    );
    deskSegmentStatiscsBak.value = deskSegmentStatiscs.value.filter(
      (p) => p.segmentName === name
    );
  }
};
const deskClick = () => {
  const name = mealtypes.value.filter(
    (p) => p.segmenttype === mealtype.value.segmenttype
  )[0]?.segmentname;
  isSprand.value = !isSprand.value;
  if (isSprand.value) {
    deskSegmentStatiscsBak.value = JSON.parse(
      JSON.stringify(deskSegmentStatiscs.value)
    );
  } else {
    deskSegmentStatiscsBak.value = deskSegmentStatiscs.value.filter(
      (p) => p.segmentName === name
    );
  }
};
const getDeskList2 = () => {
  rightContent.value.nuclearMeal = 0;
  getDeskList();
  rightContent.value.getList();
};
// 获取区域列表和桌位列表
const getDeskList = () => {
  getDeskOrder({
    mealDate: mealDate.value,
    segmentType: mealtype.value.segmenttype,
    endPoint: "book",
  })
    .then((res) => {
      // if (!createOrder.value) {
      //   // if (route.name !== "createorder") {
      //   selectDeskId.value = [];
      //   selectDeskList.value = [];
      // }
      let db_data = res.data.data;
      arealist.value = [];
      if (db_data) {
        db_data.forEach((area) => {
          let objDeskOrders = JSON.parse(JSON.stringify(area.deskOrders));
          setSelectedInfoByFromDb(objDeskOrders);
          arealist.value.push({
            areaid: area.areaid,
            areaname: area.areaname,
            desklist: objDeskOrders,
            select: true,
          });
        });

        arealistBak.value = JSON.parse(JSON.stringify(arealist.value));
      }
    })
    .then(() => {
      orderClose(true);
      for (let area of arealist.value) {
        //  if (route.name === "createorder") {
        area.desklist.forEach((el) => {
          if (el.order) {
            if (el.order[0].orderid !== createOrder.value?.orderId) {
              let index = selectDeskId.value.indexOf(el.desk.deskid);
              if (index > -1) {
                selectDeskId.value.splice(index, 1);
                selectDeskList.value.splice(index, 1);
                bus.emit("canceldesk", el);
              }
              store.dispatch("changeDesklist", selectDeskList);
            }
          }
        });
        // }
      }
    })
    .catch(() => {});
};
// /**
//  * Websocket用于刷新订单数据
//  */
// const getDeskListForSocket = () => getDeskOrder({mealDate:mealDate.value,segmentType:mealtype.value.segmenttype}).then(res => {
//     let db_data = res.data.data;
//     arealist.value = [];
//     if(db_data){
//         db_data.forEach(area=>{
//             setSelectedInfoByFromDb(area.deskOrders);
//             arealist.value.push({areaid:area.areaid,areaname:area.areaname,desklist:area.deskOrders});
//         });
//     }
// })
const orderClose = async (flag) => {
  id.value = "2";
  tab.value = 1;
  desklist.value = [];
  selectDeskId.value = [];
  store.dispatch("changeDesklist", []);
  store.dispatch("canselectdesk", true);
  await unloadEvent();
  if(!flag){
  getDeskList();
  }
};
bus.on("getTable", () => {
  getDeskList();
});
bus.on("listenLogout", () => {
  // console.log("监听到系统已退出");

  unloadEvent();
});
const time = ref(0);
bus.on("listenWebSocket", (data) => {
  if (data.eventSource.toUpperCase() == "BACK_TO_FRONT") {
    if (data.loginId !== JSON.parse(localStorage.getItem("user")).userId) {
      resetDeskSelectedToBlank(data);
      if (time.value === 0) {
        time.value = +new Date();
        getDeskList();
        setTimeout(() => {
          time.value = 0;
        }, 1000);
      }
    }
  }
  //定时解锁
  if (data.eventSource.toUpperCase() == "REDIS_TO_FRONT") {
    // console.log("3分钟已达释放通知："+JSON.stringify(data));

    setDeskLockToStatus(data);
    resetDeskSelectedToBlank(data);
  }
  //锁桌子
  if (data.eventSource.toUpperCase() == "FRONT_TO_BACK") {
    // if((data.eatDate+data.segmentType)!==(mealDate.value+mealtype.value.segmenttype)){
    //     return;
    // }
    if (user.value && user.value.userId == data.occupierId) {
      data.lockedByMe = 1;
      if (selectDeskId.value.indexOf(data.tableId) < 0) {
        let selectedTable = getDeskInfoByDeskId(
          data.eatDate,
          data.segmentType,
          data.tableId
        );
        if (selectedTable) {
          setSelectBlueStatus(JSON.parse(selectedTable));
        }
      }
    } else {
      data.lockedByMe = 0;
    }

    // console.log("锁桌通知："+JSON.stringify(data));
    setDeskLockToStatus(data);

    resetDeskSelectedToBlank(data);
  }
  //来电--自动跳转暂时不处理
  if (data.eventSource.toUpperCase() == "TEL_TO_FRONT") {
    // console.log("来电信息："+JSON.stringify(data));
    bus.emit("refreshCallList");
  }
});
/**
 * 修改桌位状态到指定样子
 * @param {} data
 */
const setDeskLockToStatus = (data) => {
  arealist.value.forEach((area) => {
    area.desklist.forEach((desk) => {
      if (
        desk.desk.deskid == data.tableId &&
        mealDate.value == data.eatDate &&
        mealtype.value.segmenttype == data.segmentType
      ) {
        // console.log(JSON.stringify(data));
        // console.log(JSON.stringify(desk));
        if (desk.ordertype == null && data.isSelected) {
          desk.ordertype = 7;
          desk.lockReason = data.occupierName + "正在使用该餐位";
          desk.remark = data.occupierName + "占桌";
        } else if (desk.ordertype == 7 && !data.isSelected) {
          desk.ordertype = null;
          desk.lockReason = null;
          desk.remark = null;
        }
        desk.lockedByMe = data.lockedByMe;
      }
    });
  });
};
/**
 * 反显时，取消之前的占桌状态
 * @param {} data
 */
const releaseDeskLock = () => {
  arealist.value.forEach((area) => {
    area.desklist.forEach((desk) => {
      if (desk.lockedByMe == 1) {
        desk.ordertype = null;
      }
    });
  });
};
const resetDeskSelectedToBlank = (data) => {
  // 如果选桌状态已清空，则把蓝底状态也恢复
  if (!data.isSelected) {
    let index = selectDeskId.value.indexOf(data.tableId);
    if (index > -1) {
      selectDeskList.value.splice(index, 1);
      selectDeskId.value.splice(index, 1);
    }
    setDeskSelectStatusTo(data, false);
  }
};
const setDeskSelectStatusTo = (data, isSelected) => {
  arealist.value.forEach((area) => {
    area.desklist.forEach((desk) => {
      if (
        desk.desk.deskid == data.tableId &&
        mealDate.value == data.eatDate &&
        mealtype.value.segmenttype == data.segmentType
      ) {
        desk.select = isSelected;
      }
    });
  });
};
/**
 * 根据桌位ID获取桌位信息
 * @param {*} deskId
 */
const getDeskInfoByDeskId = (eatDate, segmentType, deskId) => {
  let selected = "";
  arealist.value.forEach((area) => {
    area.desklist.forEach((desk) => {
      if (desk.desk.deskid == deskId) {
        selected = JSON.stringify(desk);
      }
    });
  });
  return selected;
};
/**
 * 从DB获取的信息选择桌位
 * @param {*} deskId
 */
const setSelectedInfoByFromDb = (deskOrders) => {
  deskOrders.forEach((desk) => {
    let strDesk = JSON.stringify(desk);
    //预订锁台
    desk.orderLock = 0;
    if (user.value !== null && desk.permissionUserIDList !== null) {
      let isInclude = desk.permissionUserIDList.includes(user.value.userId);

      if (isInclude !== true) {
        desk.orderLock = 11;
      }
    }
    if (desk.ordertype === 9) {
      desk.orderLock = 11;
    }

    if (desk.lockedByMe == 1) {
      if (selectDeskId.value.indexOf(desk.desk.deskid) < 0) {
        setSelectBlueStatus(JSON.parse(strDesk));
      }
    }
  });
};
// 选中桌位回显
bus.on("deskshow", (desklist) => {
  // let desklist = store.state.order.desklist;//选中的桌位信息

  selectDeskList.value = [];
  selectDeskId.value = [];
  orderSelectId.value = [];
  selectedLockDesks.value = [];
  if (desklist.length > 0) {
    for (let el of desklist) {
      selectDeskList.value.push(el);
      selectDeskId.value.push(el.desk.deskid);
      orderSelectId.value.push(el.desk.deskid);
    }
  } else {
    unlockDesks();
  }
  releaseDeskLock();
});
// 获取餐段信息
const getTimeTypes = () =>
  findRestaurantMealTime()
    .then((res) => {
      if (res.data.code === 401) {
        router.push({ path: "/login" });
      } else if (res.data.code === 200) {
        let time =
          (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) +
          ":" +
          (date.getMinutes() < 10
            ? "0" + date.getMinutes()
            : date.getMinutes());
        let week = date.getDay();
        let timearr = [];
        let data = res.data.data;
        if (week === 0) {
          week = 7;
        }
        for (let i = 0, len = data.length; i < len; i++) {
          let times = data[i];
          if (times.weekday === week) {
            timearr.push(times);
            mealtypes.value.push({
              segmenttype: times.segmenttype,
              segmentname: times.segmentname,
              endtime: times.endtime,
              starttime: times.starttime,
              defaulttime: times.defaulttime,
            });
            if (time >= times.starttime && time <= times.endtime) {
              if (sessionStorage.getItem("mealtype")) {
                mealtype.value = JSON.parse(sessionStorage.getItem("mealtype"));
              } else {
                mealtype.value = {
                  segmenttype: times.segmenttype,
                  segmentname: times.segmentname,
                };
              }
              store.dispatch("changeMealtype", mealtype.value);
              bus.emit("getMealType", mealtype.value);
            }
          }
        }
        bus.emit("currentMeatypes", mealtypes.value);
        if (!mealtype.value) {
          for (let t = 0, tlen = timearr.length; t < tlen; t++) {
            let t_time = timearr[t];
            if (t < tlen - 1) {
              if (time > t_time.endtime) {
                if (sessionStorage.getItem("mealtype")) {
                  mealtype.value = JSON.parse(
                    sessionStorage.getItem("mealtype")
                  );
                } else {
                  mealtype.value = {
                    segmenttype: timearr[t + 1].segmenttype,
                    segmentname: timearr[t + 1].segmentname,
                  };
                }
              }
            }
          }
          if (!mealtype.value) {
            if (sessionStorage.getItem("mealtype")) {
              mealtype.value = JSON.parse(sessionStorage.getItem("mealtype"));
            } else {
              mealtype.value = {
                segmenttype: timearr[0].segmenttype,
                segmentname: timearr[0].segmentname,
              };
            }
            store.dispatch("changeMealtype", mealtype.value);
            bus.emit("getMealType", mealtype.value);
          } else {
            store.dispatch("changeMealtype", mealtype.value);
            bus.emit("getMealType", mealtype.value);
          }
        }
      }
    })
    .finally(() => {
      getDeskList();
      // bus.emit('getMealType',mealtype.value)
    });
// 切换今、明、后
const switchDay = (d) => {
  calShow.value = false;
  choiceDay.value = d;
  let datestr = "";
  // if(d===1){
  //     datestr = formatDate('yyyy-MM-dd',new Date());
  // }else if(d===2){
  //     datestr = formatDate('yyyy-MM-dd',new Date(datearr[0],datearr[1]-1,datearr[2]-0+1));
  // }else if(d===3){
  //    datestr = formatDate('yyyy-MM-dd',new Date(datearr[0],datearr[1]-1,datearr[2]-0+2));
  // }
  datestr = formatDate(
    "yyyy-MM-dd",
    new Date(
      +new Date(datelist.value[0].dateTime) + (d - 1) * 24 * 60 * 60 * 1000
    )
  );
  //datestr = formatDate('yyyy-MM-dd',new Date(datearr[0],datearr[1],datearr[2]-0+d-1));
  mealDate.value = datestr;
  sessionStorage.setItem("mealdate", mealDate.value);
  store.dispatch("changeDate", mealDate.value);
  // bus.emit('getMealType',mealtype.value);
  // if(mealtype.value.segmenttype){
  //     getDeskList();
  // }
  setTimeout(() => {
    calShow.value = true;
  }, 10);
};
console.log("choiceDay", choiceDay.value);
// 选择餐段信息
const choiceMealtype = (type, d) => {
  switchDay(d);
  mealtype.value = type;
  sessionStorage.setItem("mealtype", JSON.stringify(type));
  getDeskList();
  store.dispatch("changeMealtype", type);
  bus.emit("getMealType", mealtype.value);
};
// 选择日期
const changeDate = (obj) => {
  mealDate.value = formatDate("yyyy-MM-dd", new Date(obj.date));
  sessionStorage.setItem("mealdate", mealDate.value);
  createDateList(new Date(mealDate.value));
  if (mealDate.value === formatDate("yyyy-MM-dd", new Date(mealDate.value))) {
    choiceDay.value = 1;
  } else if (
    mealDate.value ===
    formatDate(
      "yyyy-MM-dd",
      new Date(datearr[0], datearr[1] - 1, datearr[2] - 0 + 1)
    )
  ) {
    choiceDay.value = 2;
  } else if (
    mealDate.value ===
    formatDate(
      "yyyy-MM-dd",
      new Date(datearr[0], datearr[1] - 1, datearr[2] - 0 + 2)
    )
  ) {
    choiceDay.value = 3;
  } else {
    choiceDay.value = 0;
  }
  if (mealtype.value.segmenttype) {
    getDeskList();
  }
  store.dispatch("changeDate", formatDate("yyyy-MM-dd", new Date(obj.date)));
  // farmingDate.value = obj.ncWeek.replace('星期','周')+ " " +obj.monthCn + obj.dayCn;
  // store.dispatch('changeLunar',obj.monthCn + obj.dayCn+" "+obj.ncWeek.replace('星期','周'));
  bus.emit("getMealType", mealtype.value);
  todayCalDate.value = formatDate("yyyy-MM-dd", new Date(obj.date));
  calendarShow.value = false;
};
const selectMeat = (type, obj) => {
  mealtype.value = type;
  sessionStorage.setItem("mealtype", JSON.stringify(type));
  store.dispatch("changeMealtype", type);
  changeDate(obj);
};
//发送锁桌消息
const occupyTable = (json) => {
  console.log("发送数据:" + JSON.stringify(json));
  sendOccupyTable(json)
    .then((res) => {
      if (res.data.code == 200) {
        // console.log('已通知其他终端');
      } else {
        ElMessage({
          type: "error",
          message: res.data.msg,
        });
      }
    })
    .catch(() => {});
};
const route = useRoute();
const deleteDeskList = (desk) => {
  selectTable(desk);
};

// 选择桌位
const selectTable = (desk, deskltype) => {
  if (desk.orderLock == 11) {
    ElMessage({
      type: "error",
      message: "您无该餐位预订权限，请联系预订台！",
    });
    return;
  }
  if (location.href.includes("changetable")) {
    if (deskltype === 6 || (deskltype === 7 && desk.lockedByMe !== 1)) {
      return;
    }
    if (desk.order && desk.order[0] && desk.order[0].orderid) {
      if (desk.order[0].orderid === route.params.id) {
        return;
      }
    }
    // for(let area of arealist.value){
    //     for(let d of area.desklist){
    //         if(selectDeskId.value.includes(d.desk.deskid)&&d.desk.deskid!==desk.desk.deskid){
    //             d.select = false;
    //             controlDeskStatus(d,false,false);
    //         }
    //     }
    // }
    let desklist = JSON.parse(JSON.stringify(selectDeskList.value));
    if (!selectDeskId.value.includes(desk.desk.deskid)) {
      for (let d of desklist) {
        d.select = false;
        controlDeskStatus(d, false, false);
      }
      selectDeskList.value = [];
      selectDeskId.value = [];
      orderSelectId.value = [];
      desk.select = true;
      controlDeskStatus(desk, true, true);
      bus.emit("selectDesk", desk); //添加到订单
    } else {
      selectDeskList.value = [];
      selectDeskId.value = [];
      orderSelectId.value = [];
      desk.select = false;
      controlDeskStatus(desk, false, false);
      bus.emit("selectDesk", desk); //添加到订单
    }
    // selectDeskList.value=[];
    // selectDeskId.value=[];
    // orderSelectId.value=[];
    // if(selectDeskId.value.includes(desk.desk.deskid)){
    //     desk.select = false;
    //     controlDeskStatus(desk,false,false);
    // }else{
    //     desk.select = true;
    //     selectDeskList.value.push(desk);
    //     selectDeskId.value.push(desk.desk.deskid);
    //     orderSelectId.value.push(desk.desk.deskid);
    //     controlDeskStatus(desk,true,true);
    // }
  } else {
    if (!canselectdesk.value) {
      return;
    }

    //toCreate();
    if (route.name === "index") {
      orderSelectId.value = [];
    }
    // 在经理选择画面中，其他画面产生订单后；刷新其他桌位状态而不影响选择桌位。
    if (selectDeskId.value.indexOf(desk.desk.deskid) > -1) {
      desk.select = true;
      desk.ordertype = null;
      desk.lockReason = null;
      desk.remark = null;
    }
    if (
      (deskltype === 5 ||
        deskltype === 1 ||
        deskltype === 2 ||
        deskltype === 6 ||
        (deskltype === 7 && desk.lockedByMe !== 1) ||
        deskltype === 4) &&
      orderSelectId.value.indexOf(desk.desk.deskid) < 0
    ) {
      // 根据桌位id对列表进行排序
      bus.emit("desksort", desk.desk.deskname);
      return false;
    }
    let selectStatus = desk.select == undefined || desk.select == false;

    //     if(!user.value){
    //     user.value = JSON.parse(localStorage.getItem('user'));
    // }
    const websocketJson = {
      tableId: desk.desk.deskid,
      eatDate: mealDate.value,
      segmentType: mealtype.value.segmenttype,
      isSelected: selectStatus,
    };

    if (user.value) {
      websocketJson.occupierId = user.value.userId;
      websocketJson.occupierName = user.value.nickName;
    }
    sendOccupyTable(websocketJson);
    //     if(res.data.code===200){

    if (deskltype === 7 && desk.lockedByMe == 1) {
      desk.select = false;
      desk.ordertype = null;
      desk.lockReason = null;
      desk.remark = null;

      selectStatus = false;

      bus.emit("selectDesk", desk); //添加到订单
      controlDeskStatus(desk, selectStatus, false, true);
    } else {
      controlDeskStatus(desk, selectStatus, true, true);
      bus.emit("selectDesk", desk); //添加到订单
    }
    console.log("selectDeskId.value", selectDeskId.value);
    if (tab.value === 1) {
      changeTab(2);
    }
    //setInfo();
    // }else{
    //     ElMessage({
    //             type:'error',
    //             message:res.data.msg
    //         });
    // }
    // })
  }
};
// const addToRight=()=>
/**
 * 选择桌位处理
 * @param {*} desk 桌位信息
 * @param {*} selectStatus 选择桌位切换
 * @param {*} isSetBlue 是否做选择处理
 */
const controlDeskStatus = (desk, selectStatus, isSetBlue, flag) => {
  if (!user.value) {
    user.value = JSON.parse(localStorage.getItem("user"));
  }
  const websocketJson = {
    tableId: desk.desk.deskid,
    eatDate: mealDate.value,
    segmentType: mealtype.value.segmenttype,
    isSelected: selectStatus,
  };

  if (user.value) {
    websocketJson.occupierId = user.value.userId;
    websocketJson.occupierName = user.value.nickName;
  }
  if (!flag && (!desk.ordertype || desk.lockedByMe === 1)) {
    occupyTable(websocketJson);
  }
  //预订画面锁桌后，离开后清桌
  let jsonString = JSON.stringify(websocketJson);
  if (
    !selectedLockDesks.value.includes(jsonString) &&
    websocketJson.isSelected
  ) {
    selectedLockDesks.value.push(jsonString);
  }
  if (isSetBlue) {
    setSelectBlueStatus(desk);
  }
};
/**
 * 设置桌位选择
 * @param {*} desk
 */
const setSelectBlueStatus = (desk) => {
  if (selectDeskId.value.indexOf(desk.desk.deskid) < 0) {
    selectDeskList.value.push(desk);
    selectDeskId.value.push(desk.desk.deskid);
    desk.select = true; //调桌加桌判断条件
  } else {
    let index = selectDeskId.value.indexOf(desk.desk.deskid);
    selectDeskList.value.splice(index, 1);
    selectDeskId.value.splice(index, 1);
    desk.select = false; //调桌加桌判断条件
  }
  // if(router.currentRoute.value.name==='index'&&selectDeskList.value.length){
  //     toCreate()
  // }
  // bus.emit('viewCreate',selectDeskList.value.length > 0);
  store.dispatch("changeDesklist", selectDeskList);
};

const unlockDesks = () => {
  selectedLockDesks.value.forEach((item) => {
    const lock = JSON.parse(item);

    lock.isSelected = false;
    occupyTable(lock);
  });
};
/**
 * 关闭浏览器时的后处理
 */
const unloadEvent = async () => {
  const websocketJson = {
    eatDate: "*",
    segmentType: "*",
  };
  await clearALlSelectedTables(websocketJson);
  // .then(() => {
  stopWebSocket();
  // bus.off("listenWebSocket");
  // })
  // .catch(() => {});
};
const lookPhone = () => {
  router
    .push({
      path: "/callHistory/list",
    })
    .then(() => {
      window.location.reload();
    });
};
onBeforeUnmount(() => {
  unloadEvent();
  // console.log("已经退出预订菜单");
});
let _beforeUnload_time = 0;
let _gap_time = 0;

onMounted(() => {
  // setTimeout(() => {
  //   const userWidth =
  //     document.getElementsByClassName("loginout")[0].offsetWidth;
  //   if (document.getElementsByClassName("date-print").length) {
  //     document.getElementsByClassName("date-print")[0].style.right =
  //       userWidth + 30 + "px";
  //   }
  // }, 2000);
  window.onunload = async () => {
    _gap_time = new Date().getTime() - _beforeUnload_time;
    if (_gap_time <= 5) {
      await unloadEvent();
      // console.log("清空占桌已完成");
      return "";
    }
  };
  window.onbeforeunload = () => {
    _beforeUnload_time = new Date().getTime();
  };
  nextTick(() => {
    createDateList();
    if (localStorage.getItem("view_homeLayout") === "0") {
      callShow.value = true;
    }
    getTimeTypes();
    user.value = JSON.parse(localStorage.getItem("user"));
    restaurant.value = JSON.parse(localStorage.getItem("restaurant"));

    if (restaurant.value) {
      if (restaurant.value.sanBackColor) {
        colors.value.sankeBackColor = restaurant.value.sanBackColor;
      }
      if (restaurant.value.sanFrontColor) {
        colors.value.sankeFrontColor = restaurant.value.sanFrontColor;
      }
      if (restaurant.value.dingBackColor) {
        colors.value.yvdingBackColor = restaurant.value.dingBackColor;
        colors.value.dingBackFotterColor = restaurant.value.dingBackColor;
      }
      if (restaurant.value.selectBackColor) {
        colors.value.selectBackColor = restaurant.value.selectBackColor;
      }
    }
    //台型、人数展示方式
    showTableType.value = localStorage.getItem("view_tableType") == 1;
    setTimeout(() => {
      startWebSocket();
    }, 3000);
  });
});
</script>
<style scoped>

.area-active {
  background: #fe5353;
  color: #fff;
}
.flexbox {
  display: flex;
  align-items: center;
}

.outbox {
  flex: 1;
  height: 100%;
  overflow: auto;
}
/* 滚动条整体样式 */
.outbox::-webkit-scrollbar {
  display: none;
}

/*定义滚动条的轨道颜色、内阴影及圆角*/
.outbox::-webkit-scrollbar-track {
  display: none;
}

/*定义滑块颜色、内阴影及圆角*/
.outbox::-webkit-scrollbar-thumb {
  display: none;
}

.meal-message {
  background: #fe5353;
  border-radius: 4px;
  height: 58px;
  width: 160px;
  max-width: 160px;
  min-width: 160px;
  background-size: 100% 100%;
  color: #ffffff;
  cursor: pointer;
}
.op-calendar-pc-backtoday {
  display: none !important;
}
.op-calendar-pc-select-box .op-calendar-pc-holiday-box:nth-last-child(2) {
  display: none !important;
}
.datebox {
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-right: 4px;
  color: #000;
  height: 100%;
  margin-right: 12px;
  background: #fff;
}
.header-databox {
  flex-wrap: wrap;
  overflow: hidden;
}
.header-databox .select {
  color: #333333;
}
.meal-slot {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 50px;
  height: 100%;
  justify-content: center;
  cursor: pointer;
  color: #afb1b2;
}
.meal-slot img {
  width: 28px;
  height: 25px;
  box-sizing: content-box;
}
.datebox.select .datebox-day,
.mealslot-box .select {
  background: #fe5353 !important;
  color: #ffffff;
  border-radius: 4px;
}
.datebox.select .datebox-day.to-day,
.mealslot-box .select.to-day {
  background: #3e3cf5 !important;
}
.datebox.select .datebox-date,
.datebox.select .iconimg {
  color: #fff !important;
}
.mealslot-box .select img {
  border-radius: 25px;
  /* border: 2px solid #FFFFFF; */
}
.disabletime {
  cursor: not-allowed;
  opacity: 0.5;
}
.createorder {
  height: 40px;
  border: none;
  background: #ff5353;
  color: #ffffff;
  border-radius: 40px;
  width: 120px;
  min-width: 120px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.table-statistics {
  width: 84px;
  height: 40px;
  border-radius: 6px;
  text-align: center;
}
.table-statistics span {
  font-size: 24px;
  font-weight: bold;
  line-height: 40px;
}
.hall-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, 100px);
  justify-content: space-between;
  grid-row-gap: 10px;
  /* grid-column-gap: 10px; */
}
.hall-name {
  font-size: 16px;
  font-weight: bold;
  padding: 14px 0;
  padding-bottom: 8px;
}
.hall {
  border: 1px solid #e5e5e5;
  border-radius: 9px 9px 9px 9px;
  overflow: hidden;
  cursor: pointer;
  height: 82px;
  text-align: center;
  position: relative;
}
.hall-body {
  margin: 15px 10px 5px;
  display: flex;
  justify-content: space-between;
}
.empty-body {
  margin: 2px 10px 2px;
  color: #333;
}
.empty-body-ding {
  margin: 2px 10px 2px;
  font-size: 13px;
  color: #333;
}
.hall-footer {
  height: 30px;
  display: flex;
  padding: 0 10px;
  justify-content: space-between;
  align-items: center;
}
.hall-footer span {
  padding-right: 10px;
  border-right: 1px solid #eee5e5;
}
.empty-fotter {
  height: 30px;
  background-color: #f7f7f7;
  font-size: 12px;
}
.empty-fotter span {
  display: inline-block;
  padding: 0 10px;
  color: #ffffff;
  height: 24px;
  line-height: 24px;
  margin-top: 3px;
  border-radius: 15px;
  background-color: #fe5353;
}
.fotter-name {
  font-size: 12px;
  color: #999999;
}
.fotter-name-ding {
  font-size: 12px;
  /* color: #ffffff; */
}
.fotter-name-san {
  font-size: 12px;
  color: var(--sanke-front-color);
}
.desk-fotter {
  display: flex;
  justify-content: space-between;
  padding: 0 10px;
  align-items: center;
  height: 30px;
  font-size: 12px;
}
.yan-fotter {
  background-color: #ffebeb;
  color: #ec0b0b;
}
.ding-fotter {
  /* background-color: var(--ding-back-fotter); */
  color: #333333;
}
.liu-fotter {
  background-color: #f0faf2;
  color: #339947;
}
.suotai-fotter {
  background-color: #faedff;
  color: #9e3ac4;
  height: 30px;
  line-height: 30px;
  font-size: 12px;
}
.desk-name {
  padding-top: 6px;
}
.select-deskbox {
  color: #ffffff;
  background: var(--select-back-color);
  height: 100%;
  /* position: relative; */
}
.select-desk {
  /* padding: 15px 10px 35px; */
}
.yan {
  background-color: #ffebeb;
  color: #ec0b0b;
}
.yvding {
  background-color: var(--yvding-back-color);
  color: #333333;
}
.yvliu {
  background-color: #f0faf2;
  color: #339947;
}
.sanke {
  background: var(--sanke-back-color);
  color: var(--sanke-front-color);
}
.kedao {
  background: #ffebeb;
}
.suotai {
  background-color: #faedff;
  color: #9e3ac4;
}
.kongtai {
  background: #f7f7f7;
}
.el-print {
  height: 24px;
  line-height: 24px;
  padding: 15px;
  background-repeat: no-repeat;
  background-size: 24px 24px;
  margin-right: 12px;
}
/* .fade-enter-active,.fade-leave-active{
    transition: opacity 0.3s ease;
}
.fade-enter-from,.fade-leave-to{
    opacity: 0;
} */
.callbox {
  background-color: #ffffff;
  height: 100%;
  overflow: auto;
}
.title-tab {
  display: flex;
}
.title-tab span {
  display: inline-block;
  height: 32px;
  border-bottom: 2px solid #ffffff;
  line-height: 32px;
  cursor: pointer;
  font-size: 16px;
  margin-top: 8px;
}
.title-tab .select {
  font-weight: 500;
  /* border-bottom: 2px solid #448af8; */
}

</style>
<style lang="scss">

.datebox .iconimg {
  width: 100%;
  height: 22px;
  line-height: 22px;
  color: #afb1b2;
  /* background: #DFC1C1; */
  /* font-size: 12px; */
  text-align: center;
  border-radius: 4px;
  /* background: #fff; */
}
.header-databox .select .iconimg {
  /* background: #FF5353; */
}
.el-print {
  background: none;
}
.meal-today {
  margin-left: 20px;
  margin-right: 12px;
  width: 52px;
  min-width: 52px;
  height: 100%;
  background: #3e3cf5;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  flex-direction: column;
  cursor: pointer;
}
.meal-today-icon {
  width: 18px;
  height: 18px;
  font-size: 10px;
  border-radius: 50%;
  background: #fff;
  color: #3e3cf5;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 2px;
}
.tablelist-box {
  padding-top: 10px;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.line-content {
  background: #fdf9ba;
  padding: 4px 10px;
  color: #fe5353;
  display: flex;
  align-items: center;
  cursor: pointer;
  font-weight: bold;
  font-size: 16px;
  justify-content: space-between;
}

</style>
<style>

.textarea .el-textarea__inner {
  background: #f5f5f5;
}
.conston-btn {
  /* width: 114px; */
  height: 40px;
  border-radius: 4px;
  background: linear-gradient(180deg, #f17479 0%, #da3035 100%);
  color: #fff;
  cursor: pointer;
}
.btn-item {
  height: 40px;
  background: linear-gradient(180deg, #fff4f4 0%, #ffd7d8 100%);
  border: 1px solid #ffdfe0;
  color: #ea595d;
}
.btn-item:hover {
  color: #ea595d !important;
}
* :focus-visible {
  outline: none;
}

@media only screen and (max-width: 1440px) {
  .screen-calc {
    min-width: 340px !important;
    max-width: 340px !important;
  }
}
@media (min-width: 1441px) and (max-width: 1680px) {
  .screen-calc {
    min-width: 400px !important;
    max-width: 400px !important;
  }
}

</style>
